export enum AccountServiceError {
  AccountLimitReached = 31002,
  NoCertificateLogin = 'NoCertificateLogin',
}
